/** アシスタント猫パネル（AssistPanel）の横幅 */

export const ASSIST_PANEL_DEFAULT_WIDTH = 300;
export const ASSIST_PANEL_MIN_WIDTH = 300;
export const ASSIST_PANEL_MAX_WIDTH = 720;
/** 本文側に残す最小幅。これよりパネルを広げない */
export const ASSIST_PANEL_MAIN_MIN_WIDTH = 360;
export const ASSIST_PANEL_WIDTH_STORAGE_KEY = "nola:assist-panel-width";

export function clampAssistPanelWidth(
  width: number,
  viewportWidth = typeof window !== "undefined" ? window.innerWidth : ASSIST_PANEL_MAX_WIDTH
): number {
  const maxByViewport = Math.max(ASSIST_PANEL_MIN_WIDTH, viewportWidth - ASSIST_PANEL_MAIN_MIN_WIDTH);
  const maxWidth = Math.min(ASSIST_PANEL_MAX_WIDTH, maxByViewport);
  if (!Number.isFinite(width)) return ASSIST_PANEL_DEFAULT_WIDTH;
  return Math.min(maxWidth, Math.max(ASSIST_PANEL_MIN_WIDTH, Math.round(width)));
}

export function loadAssistPanelWidth(): number {
  try {
    const raw = localStorage.getItem(ASSIST_PANEL_WIDTH_STORAGE_KEY);
    if (raw == null) return ASSIST_PANEL_DEFAULT_WIDTH;
    return clampAssistPanelWidth(Number(raw));
  } catch {
    return ASSIST_PANEL_DEFAULT_WIDTH;
  }
}

export function saveAssistPanelWidth(width: number): void {
  try {
    localStorage.setItem(ASSIST_PANEL_WIDTH_STORAGE_KEY, String(clampAssistPanelWidth(width)));
  } catch {
    // localStorage が使えない環境では幅の永続化をスキップ
  }
}
